export const MODULES = [
    { id: 'pulse', label: 'Pulse', icon: '🏠', path: '/pulse' },
    { id: 'media-buyer', label: 'Media Buyer', icon: '📊', path: '/media-buyer' },
    { id: 'quality-control', label: 'Quality Control', icon: '📞', path: '/quality-control' },
    { id: 'guardian', label: 'Guardian', icon: '🛡️', path: '/guardian' },
    { id: 'ivr', label: 'IVR', icon: '📱', path: '/ivr' },
    { id: 'network', label: 'Network', icon: '👥', path: '/network' },
    { id: 'studio', label: 'Studio', icon: '🎬', path: '/studio' },
    { id: 'settings', label: 'Settings', icon: '⚙️', path: '/settings' },
];
export const ROLES = ['owner', 'admin', 'member', 'viewer'];
export const PLANS = ['starter', 'growth', 'enterprise'];
//# sourceMappingURL=index.js.map